import { Amplify } from './amplifyLib'

export function configureAmplify() {
  const redirectUrl = process.env.REACT_APP_URL
  const oauthDomain = process.env.REACT_APP_COGNITO_DOMAIN

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
        loginWith: {
          username: true,
          email: true,
          phone: true,
          ...(oauthDomain && {
            oauth: {
              domain: oauthDomain,
              scopes: ['phone', 'email', 'profile', 'openid'],
              redirectSignIn: redirectUrl ? [redirectUrl] : [],
              redirectSignOut: redirectUrl ? [redirectUrl] : [],
              responseType: 'code',
            },
          }),
        },
      },
    },
  })
}
